import {
  BookingKitExpensesReceiptInput,
  BookingKitType,
  TimeReportTemplateType
} from "@graphql";
import { isEmpty } from "lodash";
import { TimereportDto } from "@bonliva-crm/timereport-api-client-js";

export type FormData = {
  checkedIds: Record<string, boolean>;
  withTimeReport: boolean;
  withSickPay: boolean;
  withSubcontractorPay: boolean;
  withCustomerInvoice: boolean;
  withConsultantInvoice: boolean;
  responsibleId: string;
  managerId: string;
  comment: string;
  notes: string;
  tags: string[];
  type: BookingKitType;
  timeReportType: TimeReportTemplateType;
  receipts: Record<string, { checked: boolean; value: BookingKitExpensesReceiptInput }>;
};

export const initialValues: FormData = {
  checkedIds: {},
  receipts: {},
  withTimeReport: undefined,
  withSickPay: undefined,
  withSubcontractorPay: undefined,
  withCustomerInvoice: undefined,
  withConsultantInvoice: undefined,
  responsibleId: null,
  managerId: null,
  comment: "",
  notes: "",
  tags: [],
  type: null,
  timeReportType: TimeReportTemplateType.Basic
};

export const resetMinValues: Partial<FormData> = {
  checkedIds: {},
  receipts: {},
  withTimeReport: false,
  withSickPay: false,
  withSubcontractorPay: false,
  withCustomerInvoice: false,
  withConsultantInvoice: false,
  managerId: null
};

export const isEmptyTR = (timereportDto: TimereportDto | null) => {
  if (!timereportDto) {
    return true;
  }
  return timereportDto?.days.every(
    (x) =>
      isEmpty(x.vabTimeShifts) && isEmpty(x.sickTimeShifts) && isEmpty(x.workTimeRanges)
  );
};
